import React, { Component } from 'react'
import './event-details.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { getImageSource } from '../../../utility/image-source'
import { Constants, ImageConstants } from '../../../constants/constants'
import moment from 'moment'
class EventDetails extends Component {
  state = {
    showFaq: [],
    eventProgress: "baseline"
  }
  constructor (props) {
    super(props)
  }

  goBack = _ => {
    this.props.closeReport()
  }

  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  formatDates = (html) => {
    let i = 0

    if(html) {
      html = html.replace(/<time-comma[^>]*>([^<]+)<\/time-comma>/g, (content) => {
        content = content.replace(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/, (match) => {
          const date = this.convertDate(match, 'YYYY-MM-DDThh:mm:ssZ', "hh:mm A, ")
          return date
        })
        return content
      })
      html = html.replace(/<datemonthyear[^>]*>([^<]+)<\/datemonthyear>/g, (content) => {
        content = content.replace(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/, (match) => {
          const date = this.convertDate(match, 'YYYY-MM-DDThh:mm:ssZ', "DD MMM YYYY")
          return date
        })
        return content
      })
      html = html.replace(/<date[^>]*>([^<]+)<\/date>/g, (content) => {
        content = content.replace(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/, (match) => {
          const date = this.convertDate(match, 'YYYY-MM-DDThh:mm:ssZ', "DD MMM")
          return date
        })
        return content
      })
      html = html.replace(/<time[^>]*>([^<]+)<\/time>/g, (content) => {
        content = content.replace(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/, (match) => {
          const date = this.convertDate(match, 'YYYY-MM-DDThh:mm:ssZ', "hh:mm A")
          return date
        })
        return content
      })
      
      
    }

   
    return html;
  }

  showFaq = index => {
    const {showFaq} = this.state
    showFaq[index] = !this.state.showFaq[index]
    this.setState({
      showFaq
    })
  }

  render () {
    const {
      event,
      cardTitle,
      getEventParticipated,
      showInviteOption,
      showParticipateEvent,
      showPerformanceReport,
    } = this.props
    const {showFaq, eventProgress} = this.state
    const importantDates = event.help?.length > 3 ? event.help[3] : {}
    const eventParticipated = getEventParticipated(event)
    console.log(event)
    return (
      <div className='event-brief'>
        <div className='header-container'>
            <div
              className='back-icon pb-4 cursor-pointer'
              onClick={this.goBack}
            >
              <FontAwesomeIcon icon={faArrowLeft} color='#1C1C1C' />
            </div>
          <div className='pb-2'>
            <span className='screen-title'>
              {event.title}
            </span>
          </div>
        </div>
        <div className='container-fluid'>
          <div className='event-list'>
            <div className={`cw-plain-card cw-plain-card-wrapper mt-2 cw-event-${cardTitle.toLowerCase()}`}>
                <div className='row'>
                  <div className='col-9 event-details'>
                    <div>
                      <img
                        className='event-poster'
                        src={event.logo}
                      />
                    </div>
                    <div>
                      <div className='event-text'>{event.title}</div>
                      <div>
                        {event.description}
                      </div>
                      <div>
                        <span className='event-dates-title'>Dates: </span>
                        {this.convertDate(
                          event.eventStartDate,
                          'YYYY-MM-DDThh:mm:ssZ'
                        )}{event.step3  ? 
                        " - " + this.convertDate(event.step3.endTime,
                          'YYYY-MM-DDThh:mm:ssZ') : ""}
                      </div>
                    </div>
                  </div>

                  <div className='col-3 event-right'>
                    {(cardTitle === 'Completed' || (cardTitle === "Active" && eventParticipated)) && (
                      <button
                        className='cw-btn-primary cw-btn-md'
                        onClick={() => showPerformanceReport(event)}
                      >
                        VIEW DETAILS
                      </button>
                    )}
                    {cardTitle === "Active" && !eventParticipated && (
                      <button
                        className='cw-btn-primary cw-btn-md  cw-btn-md2 mt-1'
                        onClick={() => showParticipateEvent(event)}
                      >
                        PARTICIPATE IN EVENT
                      </button>
                    )}
                    {(cardTitle === 'Upcoming' || cardTitle === 'Active') && event.resultAnnounced !== true && (
                      <button
                        className='cw-btn-primary cw-btn-md mt-1'
                        onClick={() => showInviteOption(event)}
                      >
                        INVITE STUDENTS
                      </button>
                    )}
                  </div>
                </div>
            </div>
          </div>
          <div className='mt-5'>
            <div className='section-title'>About</div>
            <div className='section-content'>{event.description}</div>
          </div>
          <div className='mt-5'>
            <div className='section-title'>Important Dates</div>
            <div className='section-content' dangerouslySetInnerHTML={{ __html:importantDates ? this.formatDates(importantDates.description): ""}}></div>
          </div>
          <div className='mt-5'>
            <div className='section-title'>FAQ</div>
            <div className='section-content'>
              {event.help?.map((help, index) => (
                <div className='event-faq' key={index}>
                  <div className='faq-question cursor-pointer' onClick={_ => this.showFaq(index)}>
                    <p>{help.question}</p>
                    {!showFaq[index] && 
                      <FontAwesomeIcon icon={faAngleDown} color='#1C1C1C' />
                    }
                    {showFaq[index] && 
                      <FontAwesomeIcon icon={faAngleUp} color='#1C1C1C' />
                    }
                  </div>
                  {showFaq[index] &&
                    <div className='faq-answer' dangerouslySetInnerHTML={{ __html: this.formatDates(help.description)}}></div>
                  }
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventDetails
